module.exports = __webpack_public_path__ + "img/image-edificio.59125155.jpg";